import React, { useState } from "react";
import { CitiesManagement } from "./CitiesManagement";
import { CountriesManagement } from "./CountriesManagement";
import { VehicleCategoriesManagement } from "./VehicleCategoriesManagement";
type Tab = "cities" | "countries" | "vehicle-categories";

export const SettingsView: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>("cities");

  const tabs: { id: Tab; label: string }[] = [
    { id: "cities", label: "Cities" },
    { id: "countries", label: "Countries" },
    { id: "vehicle-categories", label: "Vehicle Categories" },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-600 mt-2">
          Manage application settings and configurations
        </p>
      </div>

      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                ${
                  activeTab === tab.id
                    ? "border-primary-500 text-primary-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }
              `}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      <div>
        {activeTab === "cities" && <CitiesManagement />}
        {activeTab === "countries" && <CountriesManagement />}
        {activeTab === "vehicle-categories" && <VehicleCategoriesManagement />}
      </div>
    </div>
  );
};
